// src/pages/Private/Student/QuizView/QuizResult.jsx
import { useLocation, useNavigate } from 'react-router-dom';
import './QuizResult.css';

function QuizResult() {
  const location = useLocation();
  const navigate = useNavigate();
  const result = location.state || { score: 0, passed: false, totalQuestions: 0, correctAnswers: 0 };

  return (
    <div className="quiz-result">
      <div className="result-card">
        <div className={`result-icon ${result.passed ? 'success' : 'fail'}`}>
          {result.passed ? '🎉' : '😔'}
        </div>

        <h1>{result.passed ? 'Tebrikler!' : 'Üzgünüz!'}</h1>
        
        <p className="result-message">
          {result.passed 
            ? 'Quiz\'i başarıyla tamamladınız!' 
            : 'Quiz\'i geçemediniz. Tekrar deneyebilirsiniz.'}
        </p>

        <div className="score-circle">
          <div className="score-value">{result.score}%</div>
          <div className="score-label">Puanınız</div>
        </div>

        <div className="result-stats">
          <div className="stat-item">
            <span className="stat-label">Doğru:</span>
            <span className="stat-value correct">{result.correctAnswers}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Yanlış:</span>
            <span className="stat-value incorrect">
              {result.totalQuestions - result.correctAnswers}
            </span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Toplam:</span>
            <span className="stat-value">{result.totalQuestions}</span>
          </div>
        </div>

        <div className="result-actions">
          <button className="btn-primary" onClick={() => navigate('/student/courses')}>
            Kurslara Dön
          </button>
          <button className="btn-secondary" onClick={() => navigate(-1)}>
            Tekrar Dene
          </button>
        </div>
      </div>
    </div>
  );
}

export default QuizResult;